import type { ReactNode } from 'react';
import { useAuthenticatedSession } from '../../session/SessionProvider.js';
import { homeAccess, type HomeAccessRule } from './homeAccess.js';

/** Renders its children only when the company has the module on and the person may use it. */
export function HomeGate({ children, ...rule }: HomeAccessRule & { children: ReactNode }) {
  const { actor, me } = useAuthenticatedSession();
  return homeAccess(actor, me.enabledModules, rule) ? <>{children}</> : null;
}
